// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// css样式还是需要全部引入
import 'element-ui/lib/theme-chalk/index.css'
import view from './view'
import axios from 'axios'
// import infiniteScroll from "vue-infinite-scroll";
import Blob from '@/Excel/Blob'
import Export2Excel from '@/Excel/Export2Excel.js'
import {
  localToken
} from "@/libs/util";
// import {
//   HappyScroll
// } from 'vue-happy-scroll'
// import 'vue-happy-scroll/docs/happy-scroll.css'
// 引入echarts
import echarts from 'echarts'
import "echarts-liquidfill";

// axios.defaults.withCredentials=false;//让ajax携带cookie
// import plTable from 'pl-table'
// import 'pl-table/themes/index.css' // 引入样式（必须引入)，vuecli3.0不需要配置，cli2.0请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
// import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
Vue.prototype.$echarts = echarts
// Vue.use(HappyScroll)
Vue.use(view)
// Vue.use(infiniteScroll);
Vue.config.productionTip = false
Vue.prototype.$ajax = axios

//自定义组件名
// Vue.use(plTable);
// Vue.component('happy-scroll', HappyScroll)
/* eslint-disable no-new */

Vue.directive('allow', {
  bind: function(el, binding) {
    // 通过当前按钮，获取所在权限组的组名
    let permissGropName = binding.value.split(".")[0]; 
    // 通过登录成功后获取所有权限列表，如下permissGroup类型，存到vuex，其中所有名字必须均独一无二
    let permissGroup = JSON.parse(localToken.getConfiguration());
    // 按组名获取权限列表，
    let arr = permissGropName.split("_");
    if(arr[0]=="main"){
      if( permissGroup[arr[1]].indexOf(binding.value.split("_")[1]) == -1){
        el.style.backgroundColor = "rgb(233 233 233 / 57%)"
        el.style.cursor = "auto"
      }
    }else{
      if( permissGroup[permissGropName].indexOf(binding.value) == -1){
        el.style.display = "none"
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  // components: {
  //   App
  // },
  // template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js